import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { cn } from "@/lib/utils";


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmDialog',
  props: {
    open: { type: Boolean },
    title: {},
    description: {},
    btnText: {},
    btnColor: {},
    busy: { type: Boolean },
    busyText: {}
  },
  emits: ["update:open", "action"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

function handleCancel() {
  emit("update:open", false);
}

function handleAction(event: MouseEvent) {
  emit("action", event);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AlertDialog), {
    open: __props.open,
    "onUpdate:open": _cache[0] || (_cache[0] = (v) => emit('update:open', __props.busy ? true : v))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(AlertDialogContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(AlertDialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.title), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogDescription), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.description), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(AlertDialogFooter), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogCancel), {
                disabled: __props.busy,
                onClick: handleCancel
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode(" Cancel ", -1)
                ]))]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_unref(AlertDialogAction), {
                disabled: __props.busy,
                class: _normalizeClass(_unref(cn)('text-white', __props.btnColor)),
                onClick: handleAction
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.busy ? (__props.busyText ?? "Working...") : (__props.btnText ?? "Confirm")), 1)
                ]),
                _: 1
              }, 8, ["disabled", "class"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})